import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=180b103b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180b103b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180b103b')) {
      api.createRecord('180b103b', component.options)
    } else {
      api.reload('180b103b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=180b103b&scoped=true&", function () {
      api.rerender('180b103b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bI27SHJhlNcx/JS/comp/Accordion.vue"
export default component.exports